import { appApiSlice } from 'src/api/app-ApiSlice';
import { TAG_GET_DEVICES } from 'src/api/api-tags';
import { GetDevicesOfProjectResponse } from 'src/model/api/v2/data-contracts';

export const deviceV2ApiSlice = appApiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getDevices: builder.query<GetDevicesOfProjectResponse, number>({
            query: (projectId: number) => `v2/get-devices/get-devices?projectId=${projectId}`,
            providesTags: [TAG_GET_DEVICES],
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetDevicesQuery,
} = deviceV2ApiSlice;
